"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = MoveTo;
var _MoveTo = require("@adobe/react-spectrum-workflow/dist/MoveTo.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function MoveTo(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_MoveTo.A4uMoveTo, null));
}